import { render, staticRenderFns } from "./PrimaryImpact.vue?vue&type=template&id=0c81712e"
import script from "./PrimaryImpact.vue?vue&type=script&lang=js"
export * from "./PrimaryImpact.vue?vue&type=script&lang=js"
import style0 from "./PrimaryImpact.vue?vue&type=style&index=0&id=0c81712e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports